import { render } from "./GitStatistical.vue?vue&type=template&id=59efb9c2"
import script from "./GitStatistical.vue?vue&type=script&lang=js"
export * from "./GitStatistical.vue?vue&type=script&lang=js"

import "./GitStatistical.vue?vue&type=style&index=0&id=59efb9c2&lang=css"
script.render = render

export default script